import { Table, TableCell, TableRow } from '@mui/material';
import Box from '@mui/material/Box';
import TableBody from '@mui/material/TableBody';
import { sortBy } from 'lodash-es';
import { useRef } from 'react';

import { caloTheme } from '../../../../assets/themes/calo';
import { CookingStationName, FoodComponent } from '../../../../libs';
import Section from '../Section';

interface SectionTableProps {
  foodComponents: FoodComponent[];
  selectedComponentStation: CookingStationName;
  setSelectedComponentStation: (value: CookingStationName) => void;
  highlightedComponentId?: string | null;
  onHighlightEnd?: () => void;
  showAllUnits: boolean;
  selectedHours: string;
}

const MobileSectionTable = ({
  foodComponents,
  setSelectedComponentStation,
  selectedComponentStation,
  highlightedComponentId,
  onHighlightEnd,
  showAllUnits,
  selectedHours
}: SectionTableProps) => {
  const myRef = useRef<null | HTMLDivElement>(null);

  let sortedComponents = sortBy(foodComponents, 'name.en');
  if (highlightedComponentId) {
    const idx = sortedComponents.findIndex((fc) => fc.id === highlightedComponentId);
    if (idx !== -1) {
      const [highlighted] = sortedComponents.splice(idx, 1);
      sortedComponents = [highlighted, ...sortedComponents];
    }
  }

  return (
    <Box
      ref={myRef}
      sx={{
        height: '100%',
        minHeight: '1000px',
        width: '100%'
      }}
    >
      <Table stickyHeader>
        <TableBody>
          {foodComponents.length > 0 ? (
            sortedComponents.map((fc) => (
              <Section
                key={fc.id}
                foodComponent={fc}
                selectedComponentStation={selectedComponentStation}
                setSelectedComponentStation={setSelectedComponentStation}
                highlightedComponentId={highlightedComponentId}
                onHighlightEnd={onHighlightEnd}
                showAllUnits={showAllUnits}
                selectedHours={selectedHours}
              />
            ))
          ) : (
            <TableRow hover>
              <TableCell
                colSpan={4}
                sx={{
                  p: 1,
                  fontFamily: caloTheme.typography.fontFamily,
                  fontSize: '28px',
                  textTransform: 'uppercase',
                  color: caloTheme.palette.neutral600,
                  textAlign: 'center',
                  border: 'none'
                }}
              >
                No components
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
};

export default MobileSectionTable;
